export default __webpack_public_path__ + "static/scratch-overlay-0fd4f4976028e641456c77a7b5ddcfc5.png";